import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import $ from "jquery";

export default class FormIdiomas extends Component {
  constructor(props) {
    super(props);

    this.IdiomaPost = this.IdiomaPost.bind(this);
    this.IdiomaPut = this.IdiomaPut.bind(this);

    this.SelectIdiomasLevel = this.SelectIdiomasLevel.bind(this);
  }

  IdiomaPost(event) {
    event.preventDefault();
    let $this = $(this);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/usuarios/" + $this[0].props.DatosUsuario.id + "/idiomas",
      method: "POST",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: {
        name: event.target["name"].value,
        languageLevelId: event.target["languageLevelId"].value,
        certificate: event.target["certificate"].value,
      },
    };
    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se ha añadido el idioma correctamente", "success");
        $this[0].props.setIdioma(response);
      })
      .fail($this[0].props.ErrorHandling);
  }

  IdiomaPut(event) {
    event.preventDefault();
    let $this = $(this);
    let settings = {
      url: process.env.REACT_APP_API_URL + "/usuarios/" + $this[0].props.DatosUsuario.id + "/idiomas/" + $this[0].props.DatosUsuario.datosIdiomas.idiomas[this.props.id].id,
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: {
        name: event.target["name"].value,
        languageLevelId: event.target["languageLevelId"].value,
        certificate: event.target["certificate"].value,
      },
    };

    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se ha editado el idioma correctamente", "success");
        $this[0].props.putIdioma(response, $this[0].props.id);
      })
      .fail($this[0].props.ErrorHandling);
  }

  SelectIdiomasLevel() {
    let idiomasLevel = [];

    for (let i = 0; i < this.props.DatosUsuario.datosIdiomas.nivelIdiomas.length; i++) {
      idiomasLevel.push(<option value={parseInt(this.props.DatosUsuario.datosIdiomas.nivelIdiomas[i].id)}>{this.props.DatosUsuario.datosIdiomas.nivelIdiomas[i].type}</option>);
    }
    return idiomasLevel;
  }

  getDefaultValue(field) {
    let defaultvalue = null;
    if (this.props.id !== undefined) {
      defaultvalue = this.props.DatosUsuario.datosIdiomas.idiomas[this.props.id][field];
    }
    return defaultvalue;
  }

  render() {
    // Para obtener la fecha actual para la restriccion html
    // let today = utils.calculateDate();

    return (
      <Form className=" p-4" onSubmit={this.props.id !== undefined ? this.IdiomaPut : this.IdiomaPost} autoComplete="off">
        <Form.Group>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados.
            </small>
          </Form.Row>
          <Form.Label>Idioma *</Form.Label>
          <Form.Control required maxLength="45" autoComplete="nope" type="text" name="name" defaultValue={this.getDefaultValue("name")} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Nivel *</Form.Label>
          <Form.Control required maxLength="45" autoComplete="nope" as="select" name="languageLevelId" defaultValue={this.getDefaultValue("languageLevelId")}>
            {this.SelectIdiomasLevel()}
          </Form.Control>
        </Form.Group>
        <Form.Group>
          <Form.Label>Titulación *</Form.Label>
          <Form.Check type="radio" label="Sí" value="Si" name="certificate" defaultChecked={this.getDefaultValue("certificate") === "Si" ? 1 : 0} />
          <Form.Check
            required
            type="radio"
            label="No"
            value="No"
            name="certificate"
            defaultChecked={this.getDefaultValue("certificate") === "No" || this.getDefaultValue("certificate") === null ? 1 : 0}
          />
        </Form.Group>

        <Form.Group>
          <Button
            type="submit"
            variant="outline-success"
            className="btn btn-block mt-5"
            //onClick={this.props.handleButtonShow} TODO cuando se le da a guardar no se cierra el modal
            name="Cerrar"
          >
            Guardar
          </Button>
        </Form.Group>
      </Form>
    );
  }
}
